import type { ParsedMonthlyRateType } from "../../../../../common-deprecated/types/FinanceInsuranceRateTypes";

export const EQUIPMENT_V2_FINANCE_START_FETCH = "equipmentV2/finance/startFetch";
export const EQUIPMENT_V2_FINANCE_ERROR = "equipmentV2/finance/fetchError";
export const EQUIPMENT_V2_FINANCE_FINISH_FETCH = "equipmentV2/finance/finishFetch";

export type StartFetchType = {
    type: typeof EQUIPMENT_V2_FINANCE_START_FETCH;
};
export type ErrorInsuranceRateFetchType = { type: typeof EQUIPMENT_V2_FINANCE_ERROR };

export type FinishFinanceRateFetchType = {
    type: typeof EQUIPMENT_V2_FINANCE_FINISH_FETCH;
    result: ParsedMonthlyRateType;
    rates?: { [index: string]: string };
};

export const startFinanceFetch = (): StartFetchType => ({
    type: EQUIPMENT_V2_FINANCE_START_FETCH,
});

export const errorFinanceFetch = (): ErrorInsuranceRateFetchType => ({ type: EQUIPMENT_V2_FINANCE_ERROR });

export const finishFinanceFetch = (
    result: ParsedMonthlyRateType,
    rates?: { [indes: string]: string },
): FinishFinanceRateFetchType => ({
    type: EQUIPMENT_V2_FINANCE_FINISH_FETCH,
    result,
    rates,
});
export type EquipmentV2FinanceActionsType = StartFetchType | ErrorInsuranceRateFetchType | FinishFinanceRateFetchType;
